export class BuildVersion {
	public static readonly buildNumber: string = '20260904.7';
	public static readonly buildPageLink: string = 'https://dev.azure.com/csc-ddsb/OpenSIMS/_build/results?buildId=60975';
}
